import connectionsStore, { EditorData3, PlaceEditorsData3, PlaceID3 } from "@mobx/store/connections";
import { EQUIPMENT_TYPE } from "@store/Equipments/actionTypes";

export interface BuildingEditorsStateInitialized3<T = PlaceEditorsData3> {
  data: T;
  initialized?: boolean;
}


export const usePlaceEditorsState3 =
  <T = PlaceEditorsData3>(placeID?: PlaceID3, f?: (s?: PlaceEditorsData3) => T): BuildingEditorsStateInitialized3<T> | undefined => {
    const ff = f ?? ((x?: PlaceEditorsData3) => x as T)
    if (placeID === undefined) return undefined;
    const { kinds = undefined, version, initialized, saved } = connectionsStore.getPlaceStore(placeID) ?? {};
    if (kinds === undefined || version === undefined) return undefined;
    const k = Object.entries(kinds)
    return {
    data: ff({
        version,
        saved: !!saved,
        kinds: Object.fromEntries(k.map(([kind, state]) => [kind, state.data])) as { [kind in EQUIPMENT_TYPE]: EditorData3 },
    }),
    initialized
    };
}
